module.exports = __webpack_public_path__ + "static/media/404.228e4ee9.svg";